import { lazy } from 'react'
import GuestGuard from '../auth/GuestGuard'
import Loadable from '../components/Loadable'
import CompactLayout from '../layouts/compact/CompactLayout'

const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')))
const ResetPswdPage = Loadable(lazy(() => import('../pages/auth/ResetPswdPage')))
const NewPswdPage = Loadable(lazy(() => import('../pages/auth/NewPswdPage')))

const LoginRoutes = {
    path: 'auth',
    children: [
        {
            path: 'login',
            element: (
                <GuestGuard>
                    <LoginPage />
                </GuestGuard>
            )
        },
        {
            element:  <CompactLayout />,
            children: [
                {
                    path: 'olvido_clave', 
                    element: (
                        <GuestGuard>
                            <ResetPswdPage /> 
                        </GuestGuard>
                    )
                },
                {
                    path: 'restablecer_clave',
                    element: (
                        <GuestGuard>
                            <NewPswdPage />
                        </GuestGuard>
                    )
                },
            ],
        },
    ]
}

export default LoginRoutes
